import React from "react"
import { useIntl } from "react-intl"
import { Box, Button, DialogContentText, Progress, UnorderedList } from "@carrotfertility/carotene-core"
import { InfoDialog } from "@carrotfertility/carotene-core-x"
import useBenefit from "#/components/dynamic-content/hooks/useGetBenefit"
import { reimbursementCategoryNameMessageKeys as Keys } from "#/components/views/reimbursements/reimbursementCategoryNameMessageKeys"
import {
  getCategorySections,
  SingleJourneyDescription
} from "#/components/views/reimbursements/digital-benefit-guide/PayingForCareModal"

// Other categories use the Your funds journey list.
const SINGLE_JOURNEY_CATEGORIES = new Set<string>([
  Keys.FERTILITY,
  Keys.PRESERVATION,
  Keys.ADOPTION,
  Keys.GC,
  Keys.PREGNANCY,
  Keys.GAC
])

const JourneyListDescription = ({
  category,
  hasQmeCategory
}: {
  category: string
  hasQmeCategory: boolean
}): JSX.Element => {
  const { header, listItems, footer } = getCategorySections(category, hasQmeCategory)
  return (
    <>
      {header}
      {listItems && <UnorderedList>{listItems}</UnorderedList>}
      {footer}
    </>
  )
}

export const CategoryInfoDialog = ({
  category,
  categoryName,
  hasQmeCategory,
  onClose
}: {
  category: string
  categoryName: string
  hasQmeCategory: boolean
  onClose: () => void
}): JSX.Element => {
  const intl = useIntl()
  const { isLoading } = useBenefit()
  return (
    <InfoDialog
      open
      onClose={onClose}
      title={categoryName}
      slotProps={{
        title: { sx: (theme) => ({ marginBlockEnd: theme.spacing(theme.tokens.spacing.sm) }) },
        actions: { sx: (theme) => ({ paddingBlockStart: theme.spacing(theme.tokens.spacing.lg) }) }
      }}
      primaryAction={<Button onClick={onClose}>{intl.formatMessage({ defaultMessage: "Close" })}</Button>}
    >
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Progress />
        </Box>
      ) : (
        <DialogContentText component="div">
          {SINGLE_JOURNEY_CATEGORIES.has(category) ? (
            <SingleJourneyDescription category={category} />
          ) : (
            <JourneyListDescription category={category} hasQmeCategory={hasQmeCategory} />
          )}
        </DialogContentText>
      )}
    </InfoDialog>
  )
}
